
import Store from 'store'
Store.dispatch('labels/fetchLabelsFromDOM')

